import { useEffect, useRef, useState } from "react";

export function useInView(bottomMargin = "-48px") {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.06, rootMargin: `0px 0px ${bottomMargin} 0px` },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [bottomMargin]);

  return { ref, inView };
}
